import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/service-subpages.css';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Service from './pages/Service';
import Solutions from './pages/Solutions';
import Facilities from './pages/Facilities';
import Company from './pages/Company';
import Contact from './pages/Contact';

import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes with Layout */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/service" element={<Layout><Service /></Layout>} />
        <Route path="/solutions" element={<Layout><Solutions /></Layout>} />
        <Route path="/facilities" element={<Layout><Facilities /></Layout>} />
        <Route path="/company" element={<Layout><Company /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />

        {/* Admin Routes with Layout (No Header) */}
        <Route path="/cil" element={<Layout showHeader={false}><Login /></Layout>} />
        <Route path="/cil/login" element={<Layout showHeader={false}><Login /></Layout>} />
        <Route path="/cil/dashboard" element={<Layout showHeader={false}><Dashboard /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
